import { ListItemIcon, ListItemText, makeStyles, MenuItem, Theme } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import SectionClosedIcon from '@material-ui/icons/KeyboardArrowDown';
import SectionOpenIcon from '@material-ui/icons/KeyboardArrowLeft';
import * as React from 'react';
import { NavTypes } from '../layout/layoutConstants';

interface ILeftNavHeaderProps {
  collapsed: boolean;
  onExpandClick: (navType: NavTypes) => any;
  navType: NavTypes;
  icon: React.ComponentType<SvgIconProps>;
  title: string;
  hasWarningColor?: boolean;
}

const useStyles = makeStyles<Theme, Pick<ILeftNavHeaderProps, 'hasWarningColor'>>((theme: Theme) => ({
  iconColor: {
    color: ({ hasWarningColor }) => (hasWarningColor ? theme.palette.error.main : '')
  }
}));

let LeftNavHeader: React.FunctionComponent<ILeftNavHeaderProps> = ({
  navType,
  onExpandClick,
  collapsed,
  title,
  hasWarningColor,
  ...props
}) => {
  const { iconColor } = useStyles({ hasWarningColor });
  const handleNavClick = React.useCallback(() => onExpandClick(navType), [navType]);

  return (
    <MenuItem onClick={handleNavClick}>
      <ListItemIcon>{<props.icon className={iconColor} />}</ListItemIcon>
      <ListItemText primary={title} />
      {collapsed ? <SectionClosedIcon /> : <SectionOpenIcon />}
    </MenuItem>
  );
};

LeftNavHeader = React.memo<ILeftNavHeaderProps>(LeftNavHeader);
export { LeftNavHeader };
